import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openChat } from '../../actions/newbuildingConsultant';
import { helpInSearchSelector } from '../../selectors/newbuildingConsultant';
import { trackOpenChatFastSearch } from './analytics';
import { HelpInSearchButton } from '../../components/HelpInSearchButton';

export function HelpInSearchButtonContainer() {
  const dispatch = useDispatch();
  const available = useSelector(helpInSearchSelector);

  const open = () => {
    dispatch(openChat(true));
    trackOpenChatFastSearch();
  };

  if (!available) {
    return null;
  }

  return (
    <HelpInSearchButton open={open} />
  );
}
